import type { ConnectionType } from '@sembo-private/maps';

import type { RecipeMainIngredient } from '@apps/main/modules/recipe/ingredients';

import type { MonthIndex } from '@libs/sembo-dates';
import type {
  AvailabilityOrder,
  Landing,
  RecipeMetaData,
  Pax,
} from '@libs/trip-planner-interfaces';

export enum TripPlannerPage {
  // TODO: Investigate, if this could be removed
  CurrentTripPlanner = 'plan',
  TripOverview = 'tripOverview',
  FlightList = 'flights',
  FerryList = 'ferry',
  HotelSelection = 'hotelSelection',
  ActivitySelection = 'activitySelection',
  HotelDetails = 'hotelDetails',
}

// TODO: Investigate, if this could be removed
export enum OldTripPlannerView {
  ProductList = 'productList',
  ProductDetails = 'productDetails',
  Overview = 'overview',
}

export enum ModalQueryParamValue {
  Pax = 'pax',
}

export interface TripPlannerQueryParams {
  initialIngredients: RecipeMainIngredient[];
  initialPax: Pax;
  initialSelectedDate?: Date;
  initialSelectedMonth?: MonthIndex;
  initialSuggestionSortType?: AvailabilityOrder;
  landing?: Landing;
  initialMetaRooms?: string[];
  initialAffiliateName?: string;
  affiliateId?: string;
  affiliateReference?: string;
  referrerOverride?: string;
  clientId?: string;
  sessionId?: string;
  initialShowAffiliateLogo?: boolean;
  initialRedirectionToken?: string;
  returnTransport?: ConnectionType;
  metaData?: RecipeMetaData;
  aiTripId?: string;
  publishedTripId?: string;
  modal?: ModalQueryParamValue;
}

export function mapFullPathToTripPlannerPage(
  fullPath: string
): TripPlannerPage | undefined {
  if (fullPath.includes('travel/plan/overview')) {
    return TripPlannerPage.TripOverview;
  }
  if (fullPath.includes('travel/plan/hotel-selection')) {
    return TripPlannerPage.HotelSelection;
  }
  if (fullPath.includes('travel/plan/hotel-details')) {
    return TripPlannerPage.HotelDetails;
  }
  if (fullPath.includes('travel/plan/flights')) {
    return TripPlannerPage.FlightList;
  }
  if (fullPath.includes('travel/plan/ferry')) {
    return TripPlannerPage.FerryList;
  }
  if (fullPath.includes('travel/plan/activity-selection')) {
    return TripPlannerPage.ActivitySelection;
  }

  return undefined;
}
